import { Button, Col, Container, Form, Row } from "react-bootstrap";
import clsx from "classnames";
import Search from "@/assets/Search.svg";
import classes from "./styles.module.scss";
import { useCallback, useState } from "react";
import { sector_helper } from "@/helpers/sector_helper";
import { getRoute } from "@/functions/getRoute";
import { job_type_helper } from "@/helpers/job_type_helper";
import { salary_helper } from "@/helpers/salary_helper";
import { practice_area_helper } from "@/helpers/practice_area_helper";

export default function QuickJobSearch({ className, title }) {
  const [sectors] = useState(sector_helper.fetch());
  const [job_types] = useState(job_type_helper.fetch());
  const [salaries] = useState(salary_helper.fetch());
  const [practice_areas] = useState(practice_area_helper.fetch());

  const [query, setQuery] = useState("");
  const [sector, setSector] = useState("");
  const [practice_area, setPracticeArea] = useState("");
  const [location, setLocation] = useState("");
  const [job_type, setJobType] = useState([]);
  const [salary, setSalary] = useState("");
  const [radius, setRadius] = useState("");

  const handleSubmit = useCallback(() => {
    const params = new URLSearchParams({
      query,
      location,
      radius,
    });

    let urlFilters = [];
    let url = `${getRoute("jobs")}?${params.toString()}`;

    if (sector) {
      urlFilters = [...urlFilters, sector];
    }

    if (practice_area) {
      urlFilters = [...urlFilters, practice_area];
    }

    if (job_type) {
      urlFilters = [...urlFilters, ...job_type];
    }

    if (salary) {
      urlFilters = [...urlFilters, ...salary];
    }

    if (urlFilters.length > 0) {
      url = `${url}#/${urlFilters.join("/")}`;
    }

    window.location.href = `${url}/`.toLowerCase();
  }, [query, location, radius, sector, practice_area, job_type, salary]);

  return (
    <div className={clsx(className, classes.search)}>
      <Container>
        <Row>
          <Col xs={12} xl={8}>
            <div className={clsx(classes.search__hero__title)}>
              {title || "The UK's only specialist legal recruiter offering national coverage of job opportunities"}{" "}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={10}>
            <Form className={clsx(classes.search__form)} onSubmit={handleSubmit}>
              <div className="d-flex flex-column p-4">
                <h3 className="h3 mb-3">Quick job search</h3>
                <Row>
                  <Col xs={12} lg={3} className="mt-4">
                    <Form.Group>
                      <Form.Label>Job Title / Keywords</Form.Label>
                      <Form.Control
                        placeholder="Solicitor..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={3} className="mt-4">
                    <Form.Group>
                      <Form.Label>Sector (PP or In-house)</Form.Label>
                      <Form.Select value={sector} onChange={(e) => setSector(e.target.value)}>
                        <option value="">Select</option>
                        {sectors.map(({ name }) => (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={3} className="mt-4">
                    <Form.Group>
                      <Form.Label>Practice Area</Form.Label>
                      <Form.Select value={practice_area} onChange={(e) => setPracticeArea(e.target.value)}>
                        <option value="">Select</option>
                        {practice_areas.map(({ name }) => (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={3} className="mt-4">
                    <Form.Group>
                      <Form.Label>City/town or postcode</Form.Label>
                      <Form.Control
                        placeholder="London..."
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={4} className="mt-4">
                    <Form.Group>
                      <Form.Label>Job type</Form.Label>
                      <Row>
                        {job_types.map(({ title }) => (
                          <Col key={title} xs={6} sm={12} xl={6}>
                            <Form.Check
                              value={title}
                              label={title}
                              onChange={(e) => {
                                setJobType(
                                  e.target.checked ? [...job_type, title] : job_type.filter((i) => i !== title),
                                );
                              }}
                            />
                          </Col>
                        ))}
                      </Row>
                    </Form.Group>
                  </Col>
                  <Col xs={6} lg={2} className="mt-4">
                    <Form.Group>
                      <Form.Label>Salary</Form.Label>
                      <Form.Select value={salary} onChange={(e) => setSalary(e.target.value)}>
                        <option value="">Select</option>
                        {salaries.map(({ title }) => (
                          <option key={title} value={title}>
                            {title}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={2} className="mt-4">
                    <Form.Group>
                      <Form.Label>Within</Form.Label>
                      <Form.Select value={radius} onChange={(e) => setRadius(e.target.value)}>
                        <option value="5">5 miles</option>
                        <option value="10">10 miles</option>
                        <option value="20">20 miles</option>
                        <option value="30">30 miles</option>
                        <option value="40">40 miles</option>
                        <option value="50">50 miles</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={4} className="mt-5 d-flex align-items-center justify-content-center">
                    <Button variant="secondary" className="w-100" onClick={handleSubmit}>
                      <Search />
                      Search Jobs
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

QuickJobSearch.defaultProps = {
  className: "",
};

QuickJobSearch.defaultProps = {
  className: "",
  title: "", // empty string means fallback will be used
};
